import { AppDispatch } from "../redux/store";
import Keycloak from "keycloak-js";
import { resetSubscriptionsState } from "../redux/slices/consumerSubscriptionSlice";
import { Subscription } from "./types/ecommerceType";
import {
  API_BASE_URL,
  EX_FREE_FOREVER_ECOMMERCE_SUBTYPE_NAME,
  EX_INSTITUTE_PLAN_ECOMMERCE_SUBTYPE_NAME,
  EX_PREMIUM_ECOMMERCE_SUBTYPE_NAME,
} from "./constants";
import { TRACK_SESSION_TOKEN_COOKIE_KEY_NAME } from "../metrics/constants";
import { Cookies } from "react-cookie";
import { WaPackage } from "./types/AiTypes";

export const logout = (
  dispatch: AppDispatch,
  keycloak: Keycloak.KeycloakInstance
) => {
  dispatch(resetSubscriptionsState());
  keycloak.logout();
};

export const dateCustomFormatter = (
  date: Date | undefined | null
): string | undefined | null => {
  if (!date || isNaN(date.getTime())) {
    return "--";
  }

  // British English uses day-month-year order; US English uses month-day-year order, and the design is the former one
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};

export const formatDateToLocal = (
  isoString: string | undefined | null
): string => {
  if (!isoString) {
    return "--";
  }

  const date = new Date(isoString);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return date.toLocaleDateString(undefined, options);
};

export const isCurrentAppPlan = (
  subscription: Subscription | undefined | null
): boolean => {
  if (!subscription) {
    return false;
  }
  return (
    subscription.productSubType?.name === EX_PREMIUM_ECOMMERCE_SUBTYPE_NAME ||
    subscription.productSubType?.name ===
      EX_FREE_FOREVER_ECOMMERCE_SUBTYPE_NAME ||
    EX_INSTITUTE_PLAN_ECOMMERCE_SUBTYPE_NAME ===
      subscription.productSubType?.name
  );
};

export const isExtensionPremiumPlan = (
  subscription: Subscription | undefined | null
): boolean => {
  if (!subscription) {
    return false;
  }
  return (
    subscription.productSubType?.name === EX_PREMIUM_ECOMMERCE_SUBTYPE_NAME ||
    EX_INSTITUTE_PLAN_ECOMMERCE_SUBTYPE_NAME ===
      subscription.productSubType?.name
  );
};

export const sendEventToBackend = async (kcToken?: string) => {
  try {
    const cookies = new Cookies();
    const TrackSessionToken = cookies.get(TRACK_SESSION_TOKEN_COOKIE_KEY_NAME);
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

    await fetch(API_BASE_URL + "/track/session/activity", {
      method: "POST",
      credentials: "include",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
        TrackSessionToken: TrackSessionToken,
        Authorization: `Bearer ${kcToken}`,
      },
      body: JSON.stringify({
        source: {
          userAgent: navigator.userAgent,
          clientSite: "ce_hub",
          location: `{timezone: ${timeZone}}`,
        },
        events: [
          {
            type: "LOGIN",
            // data: JSON.stringify({
            //
            // })
          },
        ],
      }),
    });
  } catch (error) {
    // Log the error but don't throw it
    console.warn("Failed to send event to backend:", error);
  }
};

export const checkIfExtensionInstalled = (): boolean => {
  return !!document?.getElementById("__wa_root");
};

export const getCeSharedSubDomain = () => {
  const firstDotIndex = window.location.hostname.indexOf(".");
  return window.location.hostname.substring(
    firstDotIndex === -1 ? 0 : firstDotIndex + 1
  );
};

/**
 * If extension detects an input box, it creates the dot.
 * We can use it for determine if the extension performs grammar check
 * */
export const checkIfExtensionCreatesDot = () => {
  const elements = document?.getElementsByClassName("__ce-dot-root");
  return Object.keys(elements).length > 0;
};

/**
 * Create a script tag under document node for introducing outside JS library.
 * */
export const AddJSLibraryWithLink = (link: string) => {
  const script = document.createElement("script");
  script.src = link;
  script.async = true;
  document.body.append(script);
};

export const ConvertPackagesIntoString = (
  waPackages: WaPackage[] | undefined | null
) => {
  if (Array.isArray(waPackages)) {
    return waPackages
      .map((p) => `${p.isDefault ? "🏁" : ""} ${p.name}`)
      .join("\n");
  }
  return "";
};
